"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseBrowsePage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withMedia = _interopRequireDefault(require("react-media-query-hoc/dist/with-media"));
var _horizontalSlide = _interopRequireDefault(require("../../components/horizontal-slide"));
var _carouselSlide = _interopRequireDefault(require("../../components/carousel-slide"));
var styles = _interopRequireWildcard(require("./browse-page.style"));
var _core = require("@emotion/core");
var _excluded = ["media"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var BrowsePage = _ref => {
  var media = _ref.media,
    props = _objectWithoutProperties(_ref, _excluded);
  var SlideComponent = media.desktop ? _carouselSlide.default : _horizontalSlide.default;
  return (0, _core.jsx)("div", {
    css: styles.browsePage
  }, (0, _core.jsx)("h3", {
    css: styles.title
  }, props.title), (0, _core.jsx)(SlideComponent, props));
};
exports.BaseBrowsePage = BrowsePage;
BrowsePage.propTypes = {
  title: _propTypes.default.string,
  media: _propTypes.default.shape({
    mobile: _propTypes.default.bool,
    tablet: _propTypes.default.bool,
    desktop: _propTypes.default.bool
  })
};
BrowsePage.defaultProps = {
  title: 'Property of the Week',
  media: {
    mobile: true
  }
};
var _default = exports.default = (0, _withMedia.default)(BrowsePage);